"use client";

import { useEffect } from "react";

const TARGET_TYPES = new Set(["WebPage", "BreadcrumbList", 'NewsArticle', 'Brand', 'ItemList', 'Car']);

function getSchemaTypes(raw: string | null): string[] {
    if (!raw) return [];

    try {
        const parsed = JSON.parse(raw);
        const types: string[] = [];

        const extractTypes = (node: any) => {
            if (!node || typeof node !== "object") return;

            // Handle @type
            const type = node["@type"];

            if (typeof type === "string") {
                types.push(type);
            } else if (Array.isArray(type)) {
                for (const t of type) {
                    if (typeof t === "string") {
                        types.push(t);
                    }
                }
            }

            // Handle @graph
            if (Array.isArray(node["@graph"])) {
                for (const item of node["@graph"]) {
                    extractTypes(item);
                }
            }
        };

        if (Array.isArray(parsed)) {
            parsed.forEach(extractTypes);
        } else {
            extractTypes(parsed);
        }

        return types;
    } catch {
        return [];
    }
}

export default function SchemaDeduper() {
    useEffect(() => {
        const scripts = Array.from(
            document.querySelectorAll<HTMLScriptElement>('script[type="application/ld+json"]')
        );

        const seenTypes = new Set<string>();

        for (const script of scripts) {
            const types = getSchemaTypes(script.textContent);
            let shouldRemove = false;

            for (const type of types) {
                if (!TARGET_TYPES.has(type)) continue;
                if (seenTypes.has(type)) {
                    shouldRemove = true;
                    break;
                }
            }

            if (shouldRemove) {
                script.remove();
                continue;
            }

            for (const type of types) {
                if (TARGET_TYPES.has(type)) {
                    seenTypes.add(type);
                }
            }
        }
    }, []);

    return null;
}